import axios from "axios";
import {
  CLINIC_DETAILS_FAIL,
  CLINIC_DETAILS_REQUEST,
  CLINIC_DETAILS_SUCCESS,
  CLINIC_UPDATE_FAIL,
  CLINIC_UPDATE_SUCCESS,
  CLINIC_UPDATE_REQUEST,
  CLINIC_CREATE_REQUEST,
  CLINIC_CREATE_SUCCESS,
  CLINIC_CREATE_FAIL,
  LIST_USER_CLINICS_REQUEST,
  LIST_USER_CLINICS_SUCCESS,
  LIST_USER_CLINICS_FAIL,
} from "../constants/clinicConstants";
import { logout } from "./userActions";

export const getClinicDetails = (clinicId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLINIC_DETAILS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(
      `/api/clinics/clinicDetails/${clinicId}`,
      config,
    );

    dispatch({
      type: CLINIC_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: CLINIC_DETAILS_FAIL,
      payload: message,
    });
  }
};

export const updateClinicDetails = (clinic) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLINIC_UPDATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(
      `/api/clinics/${clinic._id}/updateClinicDetails`,
      clinic,
      config,
    );

    dispatch({
      type: CLINIC_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: CLINIC_UPDATE_FAIL,
      payload: message,
    });
  }
};

export const createClinic = (newClinic) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLINIC_CREATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(`/api/clinics`, newClinic, config);

    dispatch({
      type: CLINIC_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: CLINIC_CREATE_FAIL,
      payload: message,
    });
  }
};

export const listUserClinics = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: LIST_USER_CLINICS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(`/api/clinics/getUserClinics`, config);

    dispatch({
      type: LIST_USER_CLINICS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: LIST_USER_CLINICS_FAIL,
      payload: message,
    });
  }
};
